import {
  ChatAPIClient,
  Chat,
  AnalyticsStreamCallbacks,
} from '@clickster/ui-library/dist/chat';
import { ChatsService } from '../services/chats';

/**
 * Chat adapter that implements ChatAPIClient using the existing ChatsService.
 * This bridges the ui-library chat components with the app's API layer.
 */
export const chatAdapter: ChatAPIClient = {
  getChats: async (): Promise<Chat[]> => {
    const chats = await ChatsService.getChats();
    return chats as Chat[];
  },

  getChatById: async (sessionId: string): Promise<Chat | undefined> => {
    const chat = await ChatsService.getChatById(sessionId);
    return chat as Chat | undefined;
  },

  createChat: async (agentType?: string | null): Promise<Chat> => {
    const chat = await ChatsService.createChat(agentType);
    return chat as Chat;
  },

  updateChat: async (sessionId: string, data: { agentType?: string; title?: string }): Promise<Chat> => {
    const chat = await ChatsService.updateChat(sessionId, data);
    return chat as Chat;
  },

  deleteChat: async (sessionId: string): Promise<void> => {
    await ChatsService.deleteChat(sessionId);
  },

  streamAnalytics: (
    question: string,
    sessionId: string,
    callbacks: AnalyticsStreamCallbacks
  ): (() => void) => {
    // ChatsService.streamAnalytics returns an abort function
    return ChatsService.streamAnalytics(question, sessionId, callbacks);
  },
};
